import { createContext } from "react";

const gihubContext = createContext();

export default gihubContext;